import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const InstallationFilters = ({ filters, onFiltersChange, onClearFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'planned', label: 'Planned' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'installed', label: 'Installed' },
    { value: 'verified', label: 'Verified' },
    { value: 'expired', label: 'Expired' }
  ];

  const storeOptions = [
    { value: '', label: 'All Stores' },
    { value: 'dhaka-gulshan', label: 'Dhaka - Gulshan' },
    { value: 'dhaka-dhanmondi', label: 'Dhaka - Dhanmondi' },
    { value: 'chittagong-agrabad', label: 'Chittagong - Agrabad' },
    { value: 'sylhet-zindabazar', label: 'Sylhet - Zindabazar' },
    { value: 'rajshahi-shaheb-bazar', label: 'Rajshahi - Shaheb Bazar' }
  ];

  const teamOptions = [
    { value: '', label: 'All Teams' },
    { value: 'team-alpha', label: 'Team Alpha' },
    { value: 'team-beta', label: 'Team Beta' },
    { value: 'team-gamma', label: 'Team Gamma' },
    { value: 'team-delta', label: 'Team Delta' }
  ];

  const brandOptions = [
    { value: '', label: 'All Brands' },
    { value: 'coca-cola', label: 'Coca Cola' },
    { value: 'pepsi', label: 'Pepsi' },
    { value: 'samsung', label: 'Samsung' },
    { value: 'lg', label: 'LG' },
    { value: 'walton', label: 'Walton' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value && value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="font-semibold text-foreground">Filters</h3>
          {hasActiveFilters && (
            <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="text-muted-foreground hover:text-foreground"
            >
              <Icon name="X" size={16} />
              Clear All
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
            {isExpanded ? 'Less' : 'More'}
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <Input
          type="search"
          placeholder="Search installations..."
          value={filters?.search || ''}
          onChange={(e) => handleFilterChange('search', e?.target?.value)}
          className="col-span-full md:col-span-2"
        />

        {/* Status Filter */}
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status || ''}
          onChange={(value) => handleFilterChange('status', value)}
        />

        {/* Store Filter */}
        <Select
          label="Store"
          options={storeOptions}
          value={filters?.store || ''}
          onChange={(value) => handleFilterChange('store', value)}
          searchable
        />

        {isExpanded && (
          <>
            {/* Brand Filter */}
            <Select
              label="Brand"
              options={brandOptions}
              value={filters?.brand || ''}
              onChange={(value) => handleFilterChange('brand', value)}
            />

            {/* Team Filter */}
            <Select
              label="Installation Team"
              options={teamOptions}
              value={filters?.team || ''}
              onChange={(value) => handleFilterChange('team', value)}
            />

            {/* Date Range */}
            <Input
              type="date"
              label="From Date"
              value={filters?.fromDate || ''}
              onChange={(e) => handleFilterChange('fromDate', e?.target?.value)}
            />

            <Input
              type="date"
              label="To Date"
              value={filters?.toDate || ''}
              onChange={(e) => handleFilterChange('toDate', e?.target?.value)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default InstallationFilters;